export const getStatusColor = (event: PublicEvent) => {
  const statusName = event.status?.name?.toLowerCase() || "";
  if (statusName.includes("started")) return "#4caf50";
  if (statusName.includes("progress")) return "#ff9800";
  if (statusName.includes("ended")) return "#9e9e9e";
  if (statusName.includes("cancelled")) return "#f44336";
  return "#2196f3";
};

export const getAvailableSpots = (event: PublicEvent) => {
  return event.totalCapacity - event.currentRegistrations;
};
